// extracted by mini-css-extract-plugin
export var clearButton = "input-search-module--clear-button--fae43";
export var clearIcon = "input-search-module--clear-icon--db821";
export var input = "input-search-module--input--4f86e";
export var large = "input-search-module--large--18d0a";
export var searchIcon = "input-search-module--search-icon--f493b";
export var small = "input-search-module--small--94472";
export var wrapper = "input-search-module--wrapper--eab52";